<template>
  <div class="overflow-x-hidden">
    <BaseContainer>
      <!-- Breadcrumbs -->
      <section class="flex gap-x-3 py-4 whitespace-nowrap overflow-hidden">
        <div>{{ $t('products.home') }}</div>
        <div><Icon name="chevron-right" /></div>
        <div v-if="from === 'search'">{{ $t('products.search') }}</div>
        <NuxtLinkLocale v-if="from === 'devices'" to="/devices">
          {{ $t('products.allDevice') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale v-if="from === 'styles'" to="/styles">
          {{ $t('products.allStyle') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale v-if="from === 'collabs'" to="/collabs">
          {{ $t('products.allCollabs') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale v-if="from === 'personalization'" to="/personalization">
          {{ $t('products.allCollabs') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale v-if="from === 'products'" to="/products">
          {{ $t('products.allProducts') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale v-if="from === ''" to="/devices">
          {{ $t('products.allDevice') }}
        </NuxtLinkLocale>
        <div><Icon name="chevron-right" /></div>
        <SkeletonLoader v-if="!productDetailData" class="w-[120px] h-6" />
        <div v-else class="truncate">
          {{ displayName }}
        </div>
      </section>

      <section class="flex flex-col lg:grid lg:w-auto grid-cols-2">
        <!-- Product deatil -->
        <div class="lg:hidden space-y-2 lg:pl-8 py-4">
          <div class="flex flex-row justify-between items-center">
            <SkeletonLoader
              v-if="isLoading || isPartialLoading"
              class="w-[120px] h-5"
            />
            <ProductTags
              v-else
              :new="
                !!productDetail?.tag_product?.find(
                  (item) => item?.tag_id?.name_en?.toLocaleLowerCase() === 'new'
                )
              "
              :personalizable="!!productDetail?.personalizable"
              :magsafe-compatible="
                includes(productDetail?.display_name_en, 'MagSafe')
              "
              class="flex flex-row gap-x-1 justify-start items-start"
            />

            <!-- Share -->
            <div
              ref="sharedButtonRef"
              class="flex flex-row gap-x-2 items-center"
            >
              <div v-if="openSharedMenu">
                <div class="md:hidden">
                  <div
                    class="fixed h-screen w-screen bg-black opacity-75 top-0 left-0 z-40"
                  />
                  <div
                    class="fixed bg-white w-screen z-40 bottom-0 left-0 px-[20px] py-[24px]"
                  >
                    <div class="flex justify-between items-center">
                      <div class="text-[20px] font-bold">Share to ...</div>
                      <Icon
                        name="times"
                        @click="handleChangeOpenMenu(!openSharedMenu)"
                      />
                    </div>
                    <div class="flex gap-x-10 mt-8 px-2">
                      <div
                        class="flex flex-col items-center justify-center gap-y-4"
                      >
                        <a
                          :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPath)}`"
                          target="_blank"
                          class="w-[40px] h-[40px]"
                          ><img
                            alt="facebook"
                            src="/images/social/facebook.png"
                            class="w-[40px] h-[40px]"
                          />
                        </a>
                        <div>Facebook</div>
                      </div>
                      <div
                        class="flex flex-col items-center justify-center gap-y-4"
                      >
                        <a
                          :href="`https://line.me/R/share?text=${encodeURIComponent(currentPath)}`"
                          target="_blank"
                          class="w-[40px] h-[40px]"
                          ><img
                            alt="line"
                            src="/images/social/line.png"
                            class="w-[40px] h-[40px]"
                          />
                        </a>
                        <div>Line</div>
                      </div>
                    </div>
                    <div class="flex gap-x-10 mt-8 px-2">
                      <div
                        class="flex flex-col items-center justify-center gap-y-4"
                      >
                        <div
                          class="h-[40px] w-[40px] mx-2 bg-gray-10 rounded-[8px] cursor-pointer flex items-center justify-center"
                        >
                          <Icon
                            v-if="isAlreadySharedUrl"
                            name="correct"
                            class="!text-[32px]"
                          />
                          <div v-else class="flex w-[40px] h-[40px]">
                            <img
                              alt="copy link"
                              src="/images/social/url.png"
                              class="w-[40px] h-[40px]"
                              @click="handleCopyUrl"
                            />
                          </div>
                        </div>
                        <div>Copy Link</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex mr-2 bg-gray-10 items-center rounded-[4px] h-[32px] max-md:hidden px-2 gap-x-2"
                >
                  <div class="h-[22px] bg-white rounded-[4px] cursor-pointer">
                    <Icon v-if="isAlreadySharedUrl" name="correct" class="" />
                    <div v-else class="flex w-[22px] h-[22px]">
                      <img
                        alt="url"
                        src="/images/social/url.png"
                        class="w-[22px] h-[22px]"
                        @click="handleCopyUrl"
                      />
                    </div>
                  </div>
                  <a
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPath)}`"
                    target="_blank"
                    class="w-[22px] h-[22px]"
                    ><img
                      alt="facebook"
                      src="/images/social/facebook.png"
                      class="w-[22px] h-[22px]"
                    />
                  </a>
                  <a
                    :href="`https://social-plugins.line.me/lineit/share?url=${currentPath}`"
                    target="_blank"
                    class="max-lg:hidden"
                  >
                    <img
                      alt="line"
                      src="/images/social/line.png"
                      class="w-[22px] h-[22px]"
                    />
                  </a>
                </div>
              </div>
              <div
                class="w-8 h-8 bg-gray-10 flex justify-center items-center cursor-pointer rounded-[4px]"
                @click="handleChangeOpenMenu(!openSharedMenu)"
              >
                <Icon name="share" />
              </div>
              <div
                class="w-8 h-8 bg-gray-10 flex justify-center items-center cursor-pointer rounded-[4px]"
                @click="
                  () => {
                    handleUpdateWishList()
                  }
                "
              >
                <Icon v-if="addedToWishList" name="heart" class="mt-1" />
                <Icon v-else name="heart-outline" class="mt-1" />
              </div>
            </div>
          </div>

          <div>
            <!-- Product Name -->
            <div class="text-xl md:text-[32px] font-bold">
              <SkeletonLoader v-if="!productDetailData" class="w-full h-12" />
              <h1 v-else>
                {{ displayName }}
              </h1>
            </div>

            <!-- Product Price -->
            <SkeletonLoader
              v-if="!productDetailData"
              class="w-[25%] h-[32px]"
            />
            <p v-else class="space-x-2 text-xl md:text-2xl">
              <span>
                {{
                  displayCommaNumber(
                    productDetail?.price_data?.srp_price || '0'
                  )
                }} </span
              ><span>THB</span>
            </p>
          </div>
        </div>

        <!-- Product Gallery -->
        <div v-if="size(productDetail?.product_gallery) > 0" class="lg:pr-8">
          <ProductGallery
            :sku="[productDetail?.sku, productDetail?.artwork_sku]"
            :personalizable="
              !!productDetailData?.personalizable &&
              !!productDetail?.product_preview?.[0]?.preview_image_url
            "
            :is-loading="!productDetail"
            :gallery="
              map(productDetail?.product_gallery, (item) =>
                item.image_url?.replace('/', '')
              )
            "
            :template-url="
              productDetail?.product_preview?.[0]?.preview_image_url?.replace(
                '/',
                ''
              )
            "
            :artwork-template-url="
              productDetail?.print_template_url?.replace('/', '')
            "
            :artwork-name="displayName"
            :already-save-base64="alreadySaveBase64"
            @save-base64="handleSaveBase64"
          />
        </div>
        <div v-else class="lg:pr-8" />

        <div>
          <div
            :class="
              twJoin(
                'hidden lg:block space-y-6 lg:pl-8 py-4',
                productDetail?.personalizable &&
                  'shadow-[-15px_20px_50px_-45px_rgba(0,0,0,0.2)]'
              )
            "
          >
            <div class="flex flex-row justify-between items-center">
              <SkeletonLoader
                v-if="isLoading || isPartialLoading"
                class="w-[120px] h-5"
              />
              <ProductTags
                v-else
                :new="
                  !!productDetail?.tag_product?.find(
                    (item) =>
                      item?.tag_id?.name_en?.toLocaleLowerCase() === 'new'
                  )
                "
                :personalizable="!!productDetail?.personalizable"
                :magsafe-compatible="
                  includes(productDetail?.display_name_en, 'MagSafe')
                "
                class="flex flex-row gap-x-1 justify-start items-start"
              />
              <div
                ref="sharedButtonRef2"
                class="flex flex-row gap-x-2 items-center rounded-[4px]"
              >
                <div v-if="openSharedMenu2">
                  <div class="md:hidden">
                    <div
                      class="fixed h-screen w-screen bg-black opacity-75 top-0 left-0 z-40"
                    />
                    <div
                      class="fixed bg-white w-screen z-40 bottom-0 left-0 px-[20px] py-[24px]"
                    >
                      <div class="flex justify-between items-center">
                        <div class="text-[20px] font-bold">Share to ...</div>
                        <Icon
                          name="times"
                          @click="handleChangeOpenMenu2(!openSharedMenu2)"
                        />
                      </div>
                      <div class="flex gap-x-10 mt-8 px-2">
                        <div
                          class="flex flex-col items-center justify-center gap-y-4"
                        >
                          <a
                            :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPath)}`"
                            target="_blank"
                            class="w-[40px] h-[40px]"
                            ><img
                              alt="facebook"
                              src="/images/social/facebook.png"
                              class="w-[40px] h-[40px]"
                            />
                          </a>
                          <div>Facebook</div>
                        </div>
                        <div
                          class="flex flex-col items-center justify-center gap-y-4"
                        >
                          <a
                            :href="`https://line.me/R/share?text=${encodeURIComponent(currentPath)}`"
                            target="_blank"
                            class="w-[40px] h-[40px]"
                            ><img
                              alt="line"
                              src="/images/social/line.png"
                              class="w-[40px] h-[40px]"
                            />
                          </a>
                          <div>Line</div>
                        </div>
                      </div>
                      <div class="flex gap-x-10 mt-8 px-2">
                        <div
                          class="flex flex-col items-center justify-center gap-y-4"
                        >
                          <div
                            class="h-[40px] w-[40px] mx-2 bg-gray-10 rounded-[8px] cursor-pointer flex items-center justify-center"
                          >
                            <Icon
                              v-if="isAlreadySharedUrl2"
                              name="correct"
                              class="!text-[32px]"
                            />
                            <div v-else class="flex w-[40px] h-[40px]">
                              <img
                                alt="copy link"
                                src="/images/social/url.png"
                                class="w-[40px] h-[40px]"
                                @click="handleCopyUrl"
                              />
                            </div>
                          </div>
                          <div>Copy Link</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex mr-2 bg-gray-10 items-center rounded-[4px] h-[32px] max-md:hidden px-2 gap-x-2"
                  >
                    <div class="h-[22px] bg-white rounded-[4px] cursor-pointer">
                      <Icon v-if="isAlreadySharedUrl" name="correct" class="" />
                      <div v-else class="flex w-[22px] h-[22px]">
                        <img
                          alt="url"
                          src="/images/social/url.png"
                          class="w-[22px] h-[22px]"
                          @click="handleCopyUrl"
                        />
                      </div>
                    </div>
                    <a
                      :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentPath)}`"
                      target="_blank"
                      class="w-[22px] h-[22px]"
                      ><img
                        alt="facebook"
                        src="/images/social/facebook.png"
                        class="w-[22px] h-[22px]"
                      />
                    </a>
                    <a
                      :href="`https://social-plugins.line.me/lineit/share?url=${currentPath}`"
                      target="_blank"
                      class="max-lg:hidden"
                    >
                      <img
                        alt="line"
                        src="/images/social/line.png"
                        class="w-[22px] h-[22px]"
                      />
                    </a>
                  </div>
                </div>
                <div
                  class="w-8 h-8 bg-gray-10 flex justify-center items-center cursor-pointer rounded-[4px]"
                  @click="handleChangeOpenMenu2(!openSharedMenu2)"
                >
                  <Icon name="share" />
                </div>
                <div
                  class="w-8 h-8 bg-gray-10 flex justify-center items-center cursor-pointer rounded-[4px]"
                  @click="
                    () => {
                      handleUpdateWishList()
                    }
                  "
                >
                  <Icon v-if="addedToWishList" name="heart" class="mt-1" />
                  <Icon v-else name="heart-outline" class="mt-1" />
                </div>
              </div>
            </div>

            <!-- Desktop - Name -->
            <div>
              <div class="text-[32px] font-bold">
                <SkeletonLoader v-if="!productDetailData" class="w-full h-12" />
                <h1 v-else>
                  {{ displayName }}
                </h1>
              </div>
              <SkeletonLoader v-if="!productDetail" class="w-[25%] h-[32px]" />
              <div v-else class="space-x-2 text-2xl">
                <span>{{
                  displayCommaNumber(
                    productDetail?.price_data?.srp_price || '0'
                  )
                }}</span
                ><span>THB</span>
              </div>
            </div>
          </div>
          <div class="relative">
            <div
              v-if="productDetail?.personalizable"
              class="bg-[#FAFAF9] absolute w-screen h-full left-0 top-0 -ml-5 md:ml-0"
            />
            <div
              :class="
                twJoin(
                  'bg-[#FAFAF9] relative no-scrollbar',
                  productDetail?.personalizable
                    ? 'md:pl-8 pt-8 pb-8 md:max-h-[530px] md:overflow-scroll'
                    : 'lg:ml-8'
                )
              "
            >
              <div
                :class="
                  twJoin(
                    'bg-primary-white space-y-6 pt-4 lg:pt-0 relative px-4 md:px-0 pb-4 md:pb-0',
                    productDetail?.personalizable && 'md:!p-6 rounded-2xl'
                  )
                "
              >
                <!-- Desktop - select brand -->
                <SkeletonLoader
                  v-if="pendingProductOption || pendingProductVariable"
                  class="w-full h-[90px]"
                />
                <div v-else class="flex justify-between">
                  <div
                    v-if="dropdownOptions && size(dropdownOptions) > 0"
                    :class="{
                      'flex-1': size(dropdownOptions) > 0
                    }"
                  >
                    <span>
                      {{ $t('products.select') }}
                      <span class="font-bold">{{
                        locale === 'en'
                          ? dropdownOptions?.[0]?.name_en
                          : dropdownOptions?.[0]?.name_th ||
                            dropdownOptions?.[0]?.name_en
                      }}</span>
                    </span>
                    <div
                      ref="containerRefs"
                      class="mt-[10px] flex flex-col gap-y-4"
                    >
                      <div
                        v-for="groupIndex in [
                          ...Array(Math.ceil(dropdownOptions.length / 2)).keys()
                        ]"
                        :key="groupIndex"
                        class="w-full gap-y-4 flex gap-2 md:gap-x-4"
                      >
                        <div
                          v-for="(item, index) in dropdownOptions.slice(
                            groupIndex * 2,
                            (groupIndex + 1) * 2
                          )"
                          :key="
                            item.updated_by ||
                            `placeholder-${groupIndex}-${item.name_en}`
                          "
                          :class="
                            twJoin(
                              'flex-1',

                              index == 1 &&
                                'max-w-[calc(60vw-52px)] md:max-w-none',
                              widthoptions + 72 > width &&
                                '!max-w-[calc(50vw-36px)] md:max-w-none'
                            )
                          "
                        >
                          <DropdownOption
                            v-if="
                              size(
                                getOptionByFilter(
                                  item?.product_option_id,
                                  findIndex(productOptionData, item)
                                )
                              ) > 0 && selectedOption[item.name_en]
                            "
                            :default="selectedOption[item.name_en]"
                            :options="
                              map(
                                getOptionByFilter(
                                  item?.product_option_id,
                                  findIndex(productOptionData, item)
                                ),
                                (item) => ({
                                  label: item.name_en || item.name_th,
                                  value: item.name_en
                                })
                              )
                            "
                            :class="twJoin('w-full')"
                            @change="
                              async (data) => {
                                if (data === selectedOption[item.name_en])
                                  return
                                selectedOption[item.name_en] = data
                                await checkUndefinedProduct(
                                  groupIndex * 2 + index
                                )
                                refreshProductDetailByOptionData()
                              }
                            "
                          />
                        </div>

                        <div
                          v-if="
                            dropdownOptions.slice(
                              groupIndex * 2,
                              (groupIndex + 1) * 2
                            ).length === 1
                          "
                          class="w-full"
                        >
                          <div class="h-[50px] opacity-0 rounded-md" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <SkeletonLoader
                  v-if="
                    !productProductVariableData ||
                    !productProductVariableData.length
                  "
                  class="w-full h-[215px]"
                />
                <div
                  v-else-if="size(productProductVariableData) > 0"
                  class="space-y-4"
                >
                  <div class="flex justify-between">
                    <div>
                      <span
                        v-show="
                          productProductVariableData?.some((item) =>
                            item.slug?.toLowerCase().includes('case')
                          ) || size(productProductVariableData) > 1
                        "
                      >
                        {{ $t('products.select') }}
                        <span class="font-bold">
                          {{ $t('products.selectType') }}:</span
                        >
                      </span>
                      <div
                        v-show="
                          productProductVariableData?.some((item) =>
                            item.slug?.toLowerCase().includes('case')
                          ) || size(productProductVariableData) > 1
                        "
                      >
                        {{
                          locale === 'en'
                            ? productDetail?.product_variable?.display_name_en
                            : productDetail?.product_variable
                                ?.display_name_th ||
                              productDetail?.product_variable?.display_name_en
                        }}
                      </div>
                    </div>
                    <div
                      v-if="size(productAttributes?.score) > 0"
                      class="w-[160px] space-y-2"
                    >
                      <div
                        v-for="(attr, index) in productAttributes?.score"
                        :key="index"
                        class="relative"
                      >
                        <div class="text-sm whitespace-nowrap">
                          {{
                            locale === 'en'
                              ? attr.titleEn
                              : attr.titleTh || attr.titleEn
                          }}
                        </div>
                        <div
                          :class="
                            twJoin(`relative w-full h-[2px] bg-border-divider`)
                          "
                        >
                          <div
                            :class="twJoin(`h-[2px] absolute left-0 bg-black`)"
                            :style="{
                              width: `${attr.score}%`
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      productProductVariableData?.some((item) =>
                        item.slug?.toLowerCase().includes('case')
                      ) || size(productProductVariableData) > 1
                    "
                    class="flex space-x-4 overflow-x-auto pb-4"
                  >
                    <div
                      v-for="item in orderBy(
                        orderBy(productProductVariableData, 'display_name_en', [
                          'asc'
                        ]),
                        (item) => toNumber(item?.price_data?.srp_price || '0'),
                        ['asc']
                      )"
                      :key="item?.id"
                      :class="
                        twJoin(
                          'bg-primary-white border-[2px] border-border-divider rounded-lg overflow-hidden cursor-pointer',
                          'flex-shrink-0',
                          'w-[calc((100vw-144px)/3.2)] md:w-[calc((100vw-144px)/4.4)] lg:w-[calc((50vw-72px)/4.4)] xl:lg:w-[calc((660px-72px)/4.4)]',
                          'h-[calc((100vw-144px)/3.2*1.25)]  md:h-[calc((100vw-144px)/4.7*1.25)] lg:h-[calc((50vw-72px)/4.4*1.25)] xl:h-[calc((660px-72px)/4.45*1.25)]',
                          productSlug === item?.product_data?.slug &&
                            'border-primary-tangerine'
                        )
                      "
                      @click="handleClickProductVeriable(item)"
                    >
                      <div>
                        <div
                          v-if="!item.product_data.small_thumbnail_image_url"
                          class="text-gray-50 font-medium flex justify-center items-center w-full h-full opacity-50"
                        >
                          <span>No Image</span>
                        </div>
                        <div
                          v-if="item.product_data.small_thumbnail_image_url"
                          class="w-full h-full overflow-hidden"
                        >
                          <img
                            v-if="item.product_data.small_thumbnail_image_url"
                            alt="product thumbnail"
                            :src="
                              config.public.mediaUrl +
                              item.product_data.small_thumbnail_image_url
                            "
                            class="w-full h-full object-cover object-center"
                          />
                        </div>
                      </div>
                      <div
                        :class="
                          twJoin(
                            'text-center px-2 py-1 text-[14px] md:text-[16px] font-medium text-black bg-gray-10',
                            productSlug === item?.product_data?.slug &&
                              'bg-primary-tangerine text-primary-white'
                          )
                        "
                      >
                        <span>{{
                          displayCommaNumber(item?.price_data?.srp_price || '0')
                        }}</span>
                        <span>THB</span>
                      </div>
                    </div>
                  </div>
                </div>
                <SkeletonLoader
                  v-if="isLoading || isPartialLoading"
                  class="w-full h-[38px]"
                />
                <div
                  v-if="!isLoading && !isPartialLoading"
                  class="flex flex-col gap-2"
                >
                  <div v-for="(option, i) in thumbnailOptions" :key="i">
                    <div
                      v-if="
                        size(
                          getOptionColorFilter(
                            option?.product_option_id,
                            findIndex(productOptionData, option)
                          )
                        ) > 0
                      "
                      class="flex items-center justify-between"
                    >
                      <div class="space-x-2">
                        <span>
                          {{ $t('products.select') }}
                          <span class="font-bold"
                            >{{
                              locale === 'en'
                                ? option?.name_en
                                : option?.name_th || option?.name_en
                            }}:</span
                          >
                        </span>
                        <span>{{
                          locale === 'en'
                            ? getSelectedDetail(option.name_en)?.name_en
                            : getSelectedDetail(option.name_en)?.name_th ||
                              getSelectedDetail(option.name_en)?.name_en
                        }}</span>
                      </div>
                      <div class="flex items-center gap-x-2">
                        <div
                          v-for="(variantOption, index) in getOptionColorFilter(
                            option?.product_option_id,
                            findIndex(productOptionData, option)
                          ).filter(
                            (item) =>
                              item.product_option_group_id ===
                              selectedOption.color_id
                          )"
                          :key="index"
                          :class="
                            twJoin(
                              'bg-white border rounded-full cursor-pointer',
                              selectedOption[option.name_en] ===
                                variantOption.name_en &&
                                'border-primary-tangerine'
                            )
                          "
                          @click="
                            () => {
                              if (
                                variantOption.name_en ===
                                selectedOption[option.name_en]
                              )
                                return
                              selectedOption[option.name_en] =
                                variantOption.name_en
                              refreshProductDetailByOptionData()
                            }
                          "
                        >
                          <div
                            :class="
                              twJoin(
                                'w-9 h-9 bg-gray-0 border-2 border-primary-white rounded-full'
                              )
                            "
                          >
                            <div
                              class="h-full w-full flex items-center justify-center leading-[9px] text-[9px] text-center overflow-hidden rounded-full"
                            >
                              <img
                                alt="variant option thumbnail"
                                class="w-full h-full"
                                :src="
                                  config.public.mediaUrl +
                                  variantOption.thumbnail_image_url
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    !productDetail?.personalizable &&
                    !(isLoading || isPartialLoading || isStockLoading)
                  "
                  class="mt-4 relative"
                >
                  <div
                    v-if="!!productDetail?.sku && !!productStocks"
                    class="fixed bottom-0 left-0 z-20 bg-primary-white xl:bg-transparent w-screen xl:w-auto px-5 py-4 xl:!p-0 xl:static"
                  >
                    <div v-if="productStocks?.stocks === 0">
                      <Button full intent="secondary">{{
                        $t('products.outOfStock')
                      }}</Button>
                    </div>
                    <div v-else class="flex items-center gap-x-2">
                      <div class="flex items-center gap-x-4">
                        <div class="font-medium">
                          {{ $t('products.quantity') }}:
                        </div>
                        <div class="min-w-[84px]">
                          <DropdownOption
                            :options="
                              new Array(
                                Math.min(productStocks?.stocks || 0, 10)
                              )
                                .fill(0)
                                .map((_, i) => ({
                                  label: `${i + 1}`,
                                  value: i + 1
                                }))
                            "
                            :default="quantity"
                            @change="
                              (nextValue: number) => (quantity = nextValue)
                            "
                          />
                        </div>
                      </div>
                      <Button
                        full
                        :disabled="isStockLoading"
                        :intent="
                          !productDetailData?.open_for_sale
                            ? 'disabled_secondary'
                            : 'primary'
                        "
                        @click="handleAddToCart"
                      >
                        {{
                          productDetailData?.open_for_sale
                            ? $t('products.addCart')
                            : locale == 'en'
                              ? productDetailData?.open_for_sale_message_en ||
                                'Available Soon...'
                              : productDetailData?.open_for_sale_message_th ||
                                'พร้อมจำหน่ายเร็วๆนี้...'
                        }}

                        <!-- {{ $t('products.addCart') }} -->
                      </Button>
                    </div>
                  </div>
                  <!-- <div class="mt-6 flex flex-col justify-center items-center">
                      <div
                        class="flex space-x-4 mb-2 *:w-[40px] *:h-[22px] *:object-cover"
                      >
                        <img alt="" src="/images/secure-checkout-visa.png" />
                        <img
                          alt=""
                          src="/images/secure-checkout-mastercard.png"
                        />
                        <img alt="" src="/images/secure-checkout-promptpay.png" />
                      </div>
                      <div class="text-sm">{{ $t('products.payment') }}</div>
                    </div> -->
                </div>
              </div>
              <div
                v-if="
                  productDetail?.personalizable &&
                  !isLoading &&
                  !isPartialLoading
                "
                class="relative"
              >
                <PersonalizeCaseControl
                  @loaded="
                    (newOptions) => (personalizationOptionsData = newOptions)
                  "
                  @error="personalizationError = true"
                  @valid="personalizationError = false"
                />
              </div>
              <div
                v-if="
                  productDetail?.personalizable &&
                  !(isLoading || isPartialLoading || isStockLoading)
                "
                class="mt-4 relative"
              >
                <div
                  v-if="productDetail?.artwork_sku"
                  class="fixed bottom-0 left-0 z-20 bg-primary-white md:bg-transparent w-screen md:w-auto px-5 py-4 md:!p-0 md:static"
                >
                  <div v-if="productStocks?.stocks === 0">
                    <Button full intent="secondary">{{
                      $t('products.outOfStock')
                    }}</Button>
                  </div>
                  <div v-else class="flex items-center gap-x-2">
                    <div class="flex items-center gap-x-4">
                      <div class="font-medium">
                        {{ $t('products.quantity') }}:
                      </div>
                      <div class="min-w-[84px]">
                        <DropdownOption
                          :options="
                            new Array(Math.min(productStocks?.stocks || 0, 10))
                              .fill(0)
                              .map((_, i) => ({
                                label: `${i + 1}`,
                                value: i + 1
                              }))
                          "
                          :default="quantity"
                          @change="
                            (nextValue: number) => (quantity = nextValue)
                          "
                        />
                      </div>
                    </div>
                    <Button
                      full
                      :disabled="personalizationError"
                      :intent="
                        !productDetailData?.open_for_sale
                          ? 'disabled_secondary'
                          : 'primary'
                      "
                      @click="handleAddToCart"
                    >
                      <!-- {{ $t('products.addCart') }} -->
                      {{
                        productDetailData?.open_for_sale
                          ? $t('products.addCart')
                          : locale == 'en'
                            ? productDetailData?.open_for_sale_message_en ||
                              'Available Soon...'
                            : productDetailData?.open_for_sale_message_th ||
                              'พร้อมจำหน่ายเร็วๆนี้...'
                      }}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseContainer>

    <!-- Artwork blog -->
    <div
      v-if="artworkblogdetail || productblogdetail"
      class="bg-[#F6F5F4] py-[50px] my-16 gap-y-16"
    >
      <div v-if="artworkblogdetail">
        <BaseContainer>
          <V2BlogDetail :blog-detail-data="artworkblogdetail" />
        </BaseContainer>
      </div>
      <div v-if="productblogdetail">
        <BaseContainer>
          <V2BlogDetail :blog-detail-data="productblogdetail" />
        </BaseContainer>
      </div>
    </div>

    <!-- You May Also Like -->
    <section class="mt-16 mb-16 space-y-[64px]">
      <ProductListSwiper
        :is-loading="
          isRecommendationsLoading || isLoading || isRecommendationsLoading
        "
        title="You May Also Like"
        slide-key="you-may-also-like"
        recommendation
        :data="
          filter(
            sampleSize(recommendationProducts?.hits, 10),
            (item) => item.display_name_en !== productDetail?.display_name_en
          ) || []
        "
      />
      <div
        v-if="productAttributes?.badge && productAttributes?.badge?.length > 0"
        class="bg-gray-10 py-[100px]"
      >
        <BaseContainer>
          <div class="flex flex-col items-center justify-center gap-y-6">
            <!-- <div class="text-2xl text-center lg:text-left">
                {{ $t('products.titleSpec1') }}
                <span class="font-bold">{{ $t('products.titleSpec2') }}</span>
                {{ $t('products.titleSpec3') }}
                <span class="font-bold"
                  >Not so {{ $t('products.titleSpec4') }}</span
                >.
              </div> -->
            <div
              class="flex flex-col lg:justify-center lg:flex-row w-full gap-x-2 gap-y-2 flex-wrap"
            >
              <div
                v-for="(badge, index) in productAttributes?.badge"
                :key="index"
                class="flex items-center h-[60px] py-[10px] px-2 lg:px-8 bg-primary-white rounded-2xl gap-x-4"
              >
                <img
                  v-if="badge.iconImageUrl"
                  :alt="badge.titleEn?.toLowerCase() ?? ''"
                  :src="config.public.mediaUrl + badge.iconImageUrl"
                  class="h-full"
                />
                <div>
                  {{
                    locale === 'en'
                      ? badge.titleEn
                      : badge.titleTh || badge.titleEn
                  }}
                </div>
              </div>
            </div>
          </div>
        </BaseContainer>
      </div>
    </section>

    <article :class="twJoin(productAttributes?.badge.length === 0 && 'mt-10')">
      <ArticleLinkLightTheme
        v-if="pageContent?.[0] && pageContent[0].imageUrl"
        reverse
        :image-url="pageContent[0].imageUrl"
        :title="
          locale === 'en'
            ? pageContent[0].titleEn
            : pageContent[0].titleTh || pageContent[0].titleEn
        "
        :description="
          locale === 'en'
            ? pageContent[0].descriptionEn
            : pageContent[0].descriptionTh || pageContent[0].descriptionEn
        "
        :button-title="
          locale === 'en'
            ? pageContent[0].primaryButtonEn
            : pageContent[0].primaryButtonTh || pageContent[0].primaryButtonEn
        "
        :url="pageContent[0].primaryButtonHref"
      />
      <ArticleLinkLightTheme
        v-if="pageContent?.[1] && pageContent[1].imageUrl"
        :image-url="pageContent[1].imageUrl"
        :title="
          locale === 'en'
            ? pageContent[1].titleEn
            : pageContent[1].titleTh || pageContent[1].titleEn
        "
        :description="
          locale === 'en'
            ? pageContent[1].descriptionEn
            : pageContent[1].descriptionTh || pageContent[1].descriptionEn
        "
        :button-title="
          locale === 'en'
            ? pageContent[1].primaryButtonEn
            : pageContent[1].primaryButtonTh || pageContent[1].primaryButtonEn
        "
        :url="pageContent[1].primaryButtonHref"
      />
    </article>

    <section class="mt-6">
      <ProductRecommendations />
    </section>
  </div>
</template>

<script setup lang="ts">
import {
  compact,
  filter,
  find,
  findIndex,
  forEach,
  includes,
  map,
  omit,
  orderBy,
  pick,
  range,
  sampleSize,
  size,
  slice,
  toNumber
} from 'lodash-es'
import { twJoin } from 'tailwind-merge'
import { toast } from 'vue3-toastify'
import { productRepository } from '~/repository/v2/productRepository'
import { productRepository as productRepositoryV1 } from '~/repository/productRepository'
import type { GetProductDetailResponse } from '~/types/apis/v2/getProductDetail'
import type { GetProductOptionResponse } from '~/types/apis/v2/getProductOption'
import { cmsRepository } from '~/repository/cmsRepository'
import type { GetProductVariableResponse } from '~/types/apis/v2/getProductVariable'
import type { GetOptionProductAllResponse } from '~/types/apis/v2/getOptionProductAll'
import { useCartStoreV2 } from '~/stores/v2/cartV2'
import { useWebsiteStoreV2 } from '~/stores/v2/webV2'
import ProductListSwiper from '~/components/v2/ProductListSwiper.vue'
import { BlogRepository } from '~/repository/v2/blogRepository'
import type { GetBlogDetailResponse } from '~/types/apis/v2/getBlogDetail'
import PersonalizeCaseControl from '~/components/v2/PersonalizeCaseControl.vue'
import ProductGallery from '~/components/v2/ProductGallery.vue'
import { userRepository } from '~/repository/v2/userRepository'
import { seoRepository } from '~/repository/seoRepository'

const { width } = useWindowSize()
const { locale } = useI18n()
const route = useRoute()
const router = useRouter()
const localePath = useLocalePath()
const query = computed(() => route.query)
const from = computed(() => (query.value.from as string) || '')
const params = computed(() => route.params)
const slug = computed(() => params.value.slug as string)
const productSlug = computed(() => slug.value?.[0] as string)
const artworkSlug = computed(() => slug.value?.[1] as string)
const openSharedMenu = ref(false)
const openSharedMenu2 = ref(false)
const sharedButtonRef = ref(null)
const sharedButtonRef2 = ref(null)
const isAlreadySharedUrl = ref(false)
const isAlreadySharedUrl2 = ref(false)
const isStockLoading = ref(true)
const isLoading = ref(true)
const isPartialLoading = ref(false)
const { reset } = usePersonalizationStore()
const isRecommendationsLoading = ref(true)
const quantity = ref<number>(1)
const personalizationError = ref(false)
const personalizationOptionsData =
  ref<GetProductDetailPersonalizeResponse['data']>()
const productStocks = ref<
  GetProductAvailableStocksResponse['data'][number] | null
>()
const currentPath = computed(
  () => `${window?.location?.origin}${route.fullPath}`
)
const containerRefs = ref(null)
const widthoptions = ref()
const thumbnailBase64 = ref('')
const alreadySaveBase64 = ref(false)
const { addToCart } = useCartStoreV2()
const { openCart } = useWebsiteStoreV2()

const config = useRuntimeConfig()
const { $api } = useNuxtApp()
const { $serverApi } = useNuxtApp()
const productRepo = productRepository($api)
const productRepoServerSide = productRepository($serverApi)
const productRepoV1 = productRepositoryV1($serverApi)
const blogRepo = BlogRepository($serverApi)
const personalizationStore = usePersonalizationStoreV2()
const { metadata } = storeToRefs(personalizationStore)
const firstProductVariable = useState<
  GetProductVariableResponse['data'] | null
>('first-product-variable', () => null)
const selectedOption = useState<any>(
  'selected-option-product-variable',
  () => null
)

const { on } = useEventTracking()

const { result: recommendationProducts, search: algoliaSearch } =
  useAlgoliaSearch<AlgoliaProductV2>(config.public.algoliaIndexNext as string)

const { result: currentProduct, search: getCurrentProductIndex } =
  useAlgoliaSearch<AlgoliaProductV2>(config.public.algoliaIndexNext as string)

const handleGetProductStock = async (sku: string) => {
  productRepoV1
    .getProductStock({
      body: {
        itec_skus: sku ? [sku] : []
      },
      onResponse: ({ response }) => {
        isStockLoading.value = false
        productStocks.value = {
          ...response._data.data?.[0],
          branch_stock:
            response._data.data?.[0]?.branch_stock < 0
              ? 0
              : response._data.data?.[0]?.branch_stock,
          stocks:
            response._data.data?.[0]?.stocks < 0
              ? 0
              : response._data.data?.[0]?.stocks
        }
      }
    })
    .catch((error) => console.log(error))
}

const handleSaveBase64 = (base64: string) => {
  thumbnailBase64.value = base64
  alreadySaveBase64.value = false
}

const cmsRepo = cmsRepository($serverApi)

const { data: pageContent } = await useAsyncData<
  {
    imageUrl?: string
    titleEn: string
    titleTh: string
    descriptionEn: string
    descriptionTh: string
    primaryButtonEn: string
    primaryButtonTh: string
    primaryButtonHref: string
  }[]
>('getProductDetailContent', async () => {
  const response = await cmsRepo.getWidget('product-detail')
  if (response.data?.data?.items) return response.data.data.items
  return null
})

const handleCopyUrl = () => {
  navigator.clipboard.writeText(currentPath.value)
  toast('Your link has been copied with success', {
    autoClose: 3000
  })
  isAlreadySharedUrl.value = true
}

onClickOutside(sharedButtonRef, () => handleChangeOpenMenu(false))
onClickOutside(sharedButtonRef2, () => handleChangeOpenMenu2(false))

const handleChangeOpenMenu = (data: boolean) => {
  openSharedMenu.value = data
  isAlreadySharedUrl.value = false
}

const userStore = useUserStore()
const { user, access_token } = storeToRefs(userStore)

const handleChangeOpenMenu2 = (data: boolean) => {
  openSharedMenu2.value = data
  isAlreadySharedUrl2.value = false
}

const userRepo = userRepository($api)

const { data: wishListData, refresh: refreshWishList } = await useAsyncData(
  'getWishList',
  async () => {
    const data = await userRepo.getWishList({
      params: {
        sort_by: 'all',
        per_page: 9999
      }
    })
    return data
  },
  {
    immediate: !!access_token.value,
    server: false
  }
)

const addedToWishList = computed(() =>
  find(wishListData.value?.data, {
    product_slug: productSlug.value,
    ...(artworkSlug.value && { artwork_slug: artworkSlug.value })
  })
)

const handleUpdateWishList = async () => {
  if (user.value) {
    await productRepo
      .updateWishList({
        body: {
          product_slug: productSlug.value,
          artwork_slug: artworkSlug.value
        },
        onResponse: ({ response }) => {
          if (!Array.isArray(response._data.data)) {
            on('add_to_wishlist', {
              item_name: productDetail.value?.artwork_name_en || 'Unnamed',
              item_id: productDetail.value?.artwork_sku
                ? productDetail.value?.sku + productDetail.value?.artwork_sku
                : productDetail.value?.sku || '',
              artwork_name: productDetail.value?.artwork_name_en || ''
            })
          }
        }
      })
      .catch((error) => console.log(error))

    !!access_token && refreshWishList()
  } else {
    router.push(localePath('/sign-in?redirect=' + route.path))
  }
}

const handleGetRecommendation = async (
  data: GetProductDetailResponse['data']
) => {
  const variableName = data?.display_name_en

  isRecommendationsLoading.value = true

  await getCurrentProductIndex({
    query: variableName,
    requestOptions: {
      page: 0,
      hitsPerPage: 1
    }
  })

  const product: AlgoliaProductV2 = currentProduct?.value?.hits[0]

  const excludedCategory = [
    'all_category_artwork_slug:style',
    // "all_category_artwork_slug:nature",
    // "all_category_artwork_slug:flower",
    'all_category_artwork_slug:art',
    // 'all_category_artwork_slug:graphic',
    'all_category_artwork_slug:color-pattern',
    'all_category_artwork_slug:multi'
  ]

  if (product) {
    await algoliaSearch({
      query: product.product_name_en,
      requestOptions: {
        optionalWords: product.product_name_en,
        typoTolerance: false,
        page: 0,
        hitsPerPage: 50,
        optionalFilters: compact([
          [
            // ...sampleSize(
            //   map(
            //     compact(product.all_category_product_slug),
            //     (item) => `all_category_product_slug:${item}`
            //   ).filter((item) => !includes(excludedCategory, item)),
            //   3
            // ),
            ...sampleSize(
              map(
                compact(product.all_category_artwork_slug),
                (item) => `all_category_artwork_slug:${item}`
              ).filter((item) => !includes(excludedCategory, item)),
              2
            )
          ]
        ])
      }
    })
  }

  isRecommendationsLoading.value = false
}

const handleProductDetailData = async (
  productDetailData: GetProductDetailResponse['data']
) => {
  await handleGetProductStock(productDetailData.sku)
  await handleGetRecommendation(productDetailData)
  isLoading.value = false
}

const handleClickProductVeriable = (item: any) => {
  if (isLoading.value) {
    return
  }
  if (item?.product_data?.slug != productSlug.value) {
    isStockLoading.value = true
    isLoading.value = true
    router.push({
      path: artworkSlug.value
        ? localePath(
            `/product/${item?.product_data?.slug}/${artworkSlug.value}`
          )
        : localePath(`/product/${item.product_data?.slug}`)
    })
  }
}

const { data: productDetailData } = await useAsyncData<
  GetProductDetailResponse['data'] | null
>(`getProductDetail/${productSlug.value}/${artworkSlug.value}`, async () => {
  const response = await productRepoServerSide.getProductDetail(
    artworkSlug.value
      ? `${productSlug.value}/${artworkSlug.value}/product-detail`
      : `${productSlug.value}/product-detail`
  )

  const responseData = response.data
  if (responseData) return responseData
  return null
})

const { data: productblogdetail } = await useAsyncData<
  GetBlogDetailResponse['data'] | null
>('getProductBlogDetail', async () => {
  const id = productDetailData.value?.product_blog_id
  if (!id) return null
  const response = await blogRepo.getBlogDetail(id, locale.value)
  if (response.data) {
    if (typeof response.data.blog_media_block_data === 'string') {
      response.data.blog_media_block_data = JSON.parse(
        response.data.blog_media_block_data || '[]'
      )
    }
  }
  if (response.data) return response.data
  return null
})

const { data: artworkblogdetail } = await useAsyncData<
  GetBlogDetailResponse['data'] | null
>('getArtworkBlogDetail', async () => {
  const id = productDetailData.value?.artwork_blog_id
  if (!id) return null
  const response = await blogRepo.getBlogDetail(id, locale.value)
  if (response.data) {
    if (typeof response.data.blog_media_block_data === 'string') {
      response.data.blog_media_block_data = JSON.parse(
        response.data.blog_media_block_data || '[]'
      )
    }
  }
  if (response.data) return response.data
  return null
})

const { data: pageData } = await useAsyncData<
  GetProductDetailResponse['data'] | null
>('getProductDetail', async () => {
  const { data: response } = await useQuery<GetProductDetailResponse>(
    `/v2/storefront/product/${
      artworkSlug.value
        ? `${productSlug.value}/${artworkSlug.value}/product-detail`
        : `${productSlug.value}/product-detail`
    }`,
    {
      server: true,
      watch: [productSlug, artworkSlug],
      method: 'GET'
    }
  )

  return response.value.data
})

const { execute: refreshProductDetailByOptionData } = await useAsyncData<
  GetProductDetailResponse['data'] | null
>(
  'getProductDetailByOption',
  async () => {
    let filternoid = (({ id, color_id, ...rest }) => rest)(
      selectedOption?.value || {}
    )
    const hasColorKey = Object.keys(selectedOption?.value || {}).some(
      (key) => key.toLowerCase() === 'color'
    )
    const findtype = Object.values(omit(filternoid, ['undefined'])) as string[]
    let findSlugDevice = firstProductVariable.value?.find((it) =>
      findtype
        .sort()
        .every((option, index) => option === it.options.sort()[index])
    )
    if (!(hasColorKey && findtype.length == 1)) {
      if (!findSlugDevice) {
        filternoid = (({ Color, color, color_id, id, ...rest }) => rest)(
          selectedOption?.value || {}
        )
        const findtype = Object.values(
          omit(filternoid, ['undefined'])
        ) as string[]

        findSlugDevice = firstProductVariable.value?.find((it) =>
          it.options
            .sort()
            .every((option, index) => option === findtype.sort()[index])
        )
      }
    }
    const response = await productRepo.getProductDetailByOption(
      productDetailData?.value?.product_variable?.id || '',
      {
        body: {
          artwork_slug: artworkSlug.value,
          name_en: findSlugDevice?.options
            ? findSlugDevice?.options
            : (Object.values(omit(filternoid, ['undefined'])) as string[])
        }
      }
    )
    if (response.data.slug !== productSlug.value) {
      isStockLoading.value = true
      router.push({
        path: artworkSlug.value
          ? localePath(`/product/${response.data.slug}/${artworkSlug.value}`)
          : localePath(`/product/${response.data.slug}`)
      })
    }
    if (response.data) return response.data
    return null
  },
  { server: false, immediate: false }
)

const optionProductAllState = useState<any>(
  'option-product-all-state',
  () => null
)

const { data: optionProductAll, execute: refreshOptionProductAll } =
  await useAsyncData<GetOptionProductAllResponse['data'] | null>(
    'getOptionProductAll',
    async () => {
      if (!productDetailData?.value?.product_variable?.id) return null
      const response = await productRepoServerSide.getOptionProductAll(
        productDetailData?.value?.product_variable?.id || '',
        { query: { artwork_slug: artworkSlug.value } }
      )
      optionProductAllState.value = response.data
      if (response.data) return response.data
      return null
    },
    { watch: [productDetailData] }
  )

const productDetail = computed(() => productDetailData?.value)

const { data: productAttributes } = await useAsyncData<{
  score: {
    titleTh?: string | undefined
    titleEn: string
    score: string
  }[]
  badge: {
    titleTh?: string | undefined
    titleEn: string
    iconImageUrl?: string
  }[]
}>(
  'getProductAttribute',
  async () => {
    const response = await cmsRepo.getWidget(
      `product-attributes-${productDetail.value?.id}`
    )
    if (response.data?.data?.items[0]) return response.data.data.items[0]
    return null
  },
  {
    immediate: !!productDetailData.value?.id,
    watch: [productDetail]
  }
)

const displayName = computed(() => {
  if (artworkSlug.value) {
    return locale.value === 'en'
      ? productDetail?.value?.artwork_name_en
      : productDetail?.value?.artwork_name_th ||
          productDetail?.value?.artwork_name_en
  }
  return locale.value === 'en'
    ? productDetail?.value?.display_name_en
    : productDetail?.value?.display_name_th ||
        productDetail?.value?.display_name_en
})

const { data: productOptionData, pending: pendingProductOption } =
  await useAsyncData<GetProductOptionResponse['data'] | null>(
    'getProductOption',
    async () => {
      if (!productDetailData.value?.id) return null
      const response = await productRepoServerSide.getProductOption(
        productDetailData.value?.id || '',
        { query: { artwork_slug: artworkSlug.value } }
      )
      if (response.data) {
        const sortedData = response.data.map((item) => {
          if (Array.isArray(item.product_option_id)) {
            const sortedProductOptions = orderBy(
              item.product_option_id,
              ['order'],
              ['asc']
            )
            return {
              ...item,
              product_option_id: sortedProductOptions
            }
          }
          return item
        })
        const finalSortedData = orderBy(sortedData, ['order'], ['asc'])
        return finalSortedData
      }

      return null
    },
    { watch: [productDetailData] }
  )

const getInitialProductVariable = (data: GetProductDetailResponse['data']) => {
  return data.product_option_product?.reduce(
    (prev, cur) => {
      if (
        !cur?.option_id?.product_option_group_id?.name_en ||
        !cur?.option_id?.name_en
      ) {
        return { ...prev }
      }

      return {
        ...prev,
        [cur.option_id.product_option_group_id.name_en]: cur.option_id.name_en
      }
    },
    {
      ...(data.product_option_product?.some(
        (it) =>
          it.option_id.product_option_group_id.name_en.toLowerCase() === 'model'
      )
        ? {
            id: data.product_option_product?.find(
              (it) =>
                it.option_id.product_option_group_id.name_en.toLowerCase() ===
                'model'
            )?.product_option_id
          }
        : {}),
      ...(data.product_option_product?.some(
        (it) =>
          it.option_id.product_option_group_id.name_en.toLowerCase() === 'color'
      )
        ? {
            color_id: data.product_option_product?.find(
              (it) =>
                it.option_id.product_option_group_id.name_en.toLowerCase() ===
                'color'
            )?.option_id.product_option_group_id.id
          }
        : {})
    }
  )
}

const { data: productProductVariableData, pending: pendingProductVariable } =
  await useAsyncData<GetProductVariableResponse['data'] | null>(
    'getProductProductVariable',
    async () => {
      if (!productDetailData.value?.id) return null
      const response = await productRepoServerSide.getProductVariable(
        productDetailData.value?.id || '',
        { query: { artwork_slug: artworkSlug.value } }
      )
      firstProductVariable.value = response.data

      selectedOption.value = getInitialProductVariable(productDetailData.value)
      const filternoid = (({ id, Color, color, color_id, ...rest }) => rest)(
        selectedOption.value || {}
      )

      const findtype = Object.values(
        omit(filternoid, ['undefined'])
      ) as string[]
      const filteredItem = response.data.filter((it) => {
        if (!it.options || !it.option_groups) return false
        const validIndexes = it.option_groups
          .map((type, index) => (type.toLowerCase() !== 'color' ? index : -1))
          .filter((index) => index !== -1)
        const filteredOptions = validIndexes.map((index) => it.options[index])
        // const target = validIndexes
        //   .map((index) => findtype[index]?.trim())
        //   .filter(Boolean)
        const options = filteredOptions.map((o) => o.trim())
        return (
          findtype.every((item) => options.includes(item)) &&
          options.every((item) => findtype.includes(item))
        )
      })

      const firstItem = filteredItem.find(
        (it) => it.product_data.slug === productSlug.value
      )
      const filteredData = filteredItem.filter(
        (it) => it.product_data.slug !== productSlug.value
      )
      const map = new Map()
      if (firstItem) {
        map.set(firstItem.display_name_en, firstItem)
      }

      filteredData.forEach((item) => {
        if (!map.has(item.display_name_en)) {
          map.set(item.display_name_en, item)
        }
      })
      if (response) return Array.from(map.values())

      return null
    },
    { lazy: true, watch: [productDetailData] }
  )

const thumbnailOptions = computed(() =>
  filter(
    productOptionData.value,
    (item, index) =>
      getOptionByFilter(item?.product_option_id, index)?.every(
        (data) => data.thumbnail_image_url
      ) && size(item?.product_option_id) > 0
  )
)

const dropdownOptions = computed(() => {
  if (!selectedOption.value) return null
  return filter(
    productOptionData.value,
    (item, index) =>
      !getOptionByFilter(item?.product_option_id, index)?.every(
        (data) => data.thumbnail_image_url
      ) && size(item?.product_option_id) > 0
  ).filter((item) => {
    return Object.keys(selectedOption.value).some((key) => item.name_en === key)
  })
})
const getSelectedDetail = (name_en: string) => {
  return find(
    find(productOptionData.value, (item) => item.name_en === name_en)
      ?.product_option_id,
    (item) => item.name_en === selectedOption.value?.[name_en]
  )
}

const getOptionByFilter = (
  option: GetProductOptionResponse['data'][0]['product_option_id'],
  index: number
) => {
  const newOptionProductAll =
    optionProductAll?.value || optionProductAllState?.value
  if (!productOptionData?.value || !newOptionProductAll) return []
  if (index === 0) return orderBy(option, ['order', 'name_en'], ['asc'])
  let optionProduct = optionProductAll?.value

  forEach(range(index), (id: number) => {
    optionProduct = filter(newOptionProductAll, (item) => {
      if (
        productOptionData?.value === null ||
        !productOptionData?.value?.[id]?.name_en
      )
        return false
      return (
        item?.[productOptionData.value[id].name_en]?.name_en ===
        selectedOption?.value?.[
          productOptionData?.value?.[id]?.name_en as string
        ]
      )
    })
  })

  return filter(orderBy(option, ['order', 'name_en'], ['asc']), (item) =>
    optionProduct?.some((data) => {
      return (
        data?.[productOptionData?.value?.[index]?.name_en as keyof typeof data]
          ?.name_en === item.name_en
      )
    })
  ) as GetProductOptionResponse['data'][0]['product_option_id']
}
const getOptionColorFilter = (
  option: GetProductOptionResponse['data'][0]['product_option_id'],
  index: number
) => {
  const newOptionProductAll =
    optionProductAll?.value || optionProductAllState?.value
  if (!productOptionData?.value || !newOptionProductAll) return []
  if (index === 0) return orderBy(option, ['order', 'name_en'], ['asc'])
  let optionProduct = optionProductAll?.value

  forEach(range(index), (id: number) => {
    optionProduct = filter(newOptionProductAll, (item) => {
      if (
        productOptionData?.value === null ||
        !productOptionData?.value?.[id]?.name_en
      )
        return false
      return (
        item?.[productOptionData.value[id].name_en]?.name_en ===
        selectedOption?.value?.[
          productOptionData?.value?.[id]?.name_en as string
        ]
        //   &&
        // item?.[productOptionData.value[id].name_en]?.product_option_id ==
        //   selectedOption?.value?.id
      )
    })
  })
  return filter(orderBy(option, ['order', 'name_en'], ['asc']), (item) =>
    optionProduct?.some((data) => {
      return (
        data?.[productOptionData?.value?.[index]?.name_en as keyof typeof data]
          ?.name_en === item.name_en &&
        data.Model?.product_option_id == selectedOption?.value?.id
      )
    })
  ) as GetProductOptionResponse['data'][0]['product_option_id']
}
const checkUndefinedProduct = async (index: number) => {
  if (size(selectedOption.value) === 1) return
  let i = index
  const list = []
  for await (const item of slice(productOptionData?.value, 0, index + 1)) {
    list.push(item.name_en)
  }
  for await (const item of slice(productOptionData?.value, index + 1)) {
    if (size(getOptionByFilter(item?.product_option_id, i + 1)) > 0) {
      list.push(item.name_en)
      selectedOption.value[item.name_en] = getOptionByFilter(
        item?.product_option_id,
        i + 1
      )?.[0]?.name_en
    }
    i += 1
  }
  selectedOption.value = pick(selectedOption?.value, list)
}

const handleAddToCart = async () => {
  if (
    productStocks.value &&
    productDetail.value?.slug &&
    productDetail?.value?.price_data?.srp_price &&
    productSlug?.value
  ) {
    if (productDetail.value?.personalizable) {
      await Promise.all([
        (alreadySaveBase64.value = true),
        new Promise((resolve) => setTimeout(resolve, 700))
      ])
    }
    const payload = {
      productSlug: productSlug?.value,
      artworkSlug: artworkSlug?.value || undefined,
      quantity: quantity.value,
      productId: productDetail.value.id,
      artworkProductId: productDetail.value.artwork_product_id ?? '',
      productSku: productDetail.value.sku,
      ...(productDetail?.value?.personalizable
        ? {
            personalization_base64: thumbnailBase64.value,
            metadata: {
              ...(metadata.value || {}),
              backgroundUrl:
                productDetail?.value?.product_preview?.[0]?.preview_image_url,
              artworkUrl: productDetail?.value?.print_template_url
            }
          }
        : {})
    }
    on('add_to_cart', {
      item_category: getItemCategory(),
      item_name: productDetail.value.display_name_en,
      artwork_name: productDetail.value.artwork_name_en,
      item_id: productDetail.value.sku,
      quantity: 1
    })
    addToCart(payload)
    openCart()
    alreadySaveBase64.value = false
  }
}

const seoRepo = seoRepository($serverApi)

// ─── SEO Data ────────────────────────────────────────────────────
const { data: pageDataStatic } = await useAsyncData(
  'getSeoProductDetailPage',
  async () => {
    const pageStaticData = await seoRepo.getSeo('product-detail')
    return pageStaticData
  }
)

function getLocalizedTemplate(
  meta: { en?: string; th?: string } | undefined,
  locale: string
): string {
  return locale === 'en' ? (meta?.en ?? '') : (meta?.th ?? meta?.en ?? '')
}

const seoTitle = computed(() => {
  const defaultTitle = getLocalizedTemplate(
    pageDataStatic.value?.meta_title,
    locale.value
  )

  if (locale.value === 'en') {
    return (
      pageData.value?.artwork_meta_title_en ||
      pageData.value?.artwork_meta_title_th ||
      pageData.value?.product_meta_title_en ||
      pageData.value?.product_meta_title_th ||
      defaultTitle
    )
  } else if (locale.value === 'th') {
    return (
      pageData.value?.artwork_meta_title_th ||
      pageData.value?.artwork_meta_title_en ||
      pageData.value?.product_meta_title_th ||
      pageData.value?.product_meta_title_en ||
      defaultTitle
    )
  }

  return defaultTitle
})

const seoDescription = computed(() => {
  const defaultDescription = getLocalizedTemplate(
    pageDataStatic.value?.meta_description,
    locale.value
  )

  if (locale.value === 'en') {
    return (
      pageData.value?.artwork_meta_description_en ||
      pageData.value?.artwork_meta_description_th ||
      pageData.value?.product_meta_description_en ||
      pageData.value?.product_meta_description_th ||
      defaultDescription
    )
  } else if (locale.value === 'th') {
    return (
      pageData.value?.artwork_meta_description_th ||
      pageData.value?.artwork_meta_description_en ||
      pageData.value?.product_meta_description_th ||
      pageData.value?.product_meta_description_en ||
      defaultDescription
    )
  }

  return defaultDescription
})

useSeoMeta({
  title: seoTitle.value,
  description: seoDescription.value,
  ogImage: config.public.mediaUrl + pageData.value?.thumbnail_image_url,
  keywords: pageDataStatic.value?.meta_keyword,
  ogImageSecureUrl: config.public.mediaUrl + pageData.value?.thumbnail_image_url
})

const getWidth = () => {
  if (containerRefs.value) {
    widthoptions.value = (containerRefs.value as HTMLElement).clientWidth
  }
}
watch(
  route,
  () => {
    productDetailData?.value?.product_variable?.id && refreshOptionProductAll()
  },
  { deep: true, immediate: true }
)
watch(
  dropdownOptions,
  async (newVal, oldVal) => {
    if (newVal && newVal.length !== oldVal?.length && newVal.length) {
      await nextTick()
      setTimeout(() => {
        getWidth()
      }, 500)
    }
  },
  { deep: true, immediate: true }
)
watch([isLoading, isPartialLoading], () => {
  getWidth()
})

watchEffect(() => {
  if (!pageData.value) return

  console.log('log data before use schema', pageData.value)
  useSchemaOrg([
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: pageData.value?.display_name_en,
      description: `This is the ${pageData.value?.product_name_en || pageData.value?.product_name_th || pageData.value?.display_name_en || 'CaseClub Product'}`,
      sku:
        pageData.value?.sku && pageData.value?.artwork_sku
          ? pageData.value?.sku + pageData.value?.artwork_sku
          : undefined,
      productID: pageData.value?.slug,
      image: config.public.mediaUrl + pageData.value?.thumbnail_image_url,
      category:
        pageData.value?.category && pageData.value?.category.length
          ? pageData.value?.category
              .map((item: any) => item?.category_id?.name_en)
              .join('/')
          : undefined,
      brand: {
        '@type': 'Brand',
        name: 'CaseClub'
      },
      offers: {
        '@type': 'Offer',
        price: pageData.value?.price_data?.srp_price,
        priceCurrency: 'THB',
        availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition',
        seller: {
          '@type': 'Organization',
          name: 'CaseClub'
        },
        url: `${config.public.siteUrl}${route.fullPath}`
      }
    }
  ])
})

onBeforeMount(() => {
  const fromOtherPage =
    !includes(router.options.history.state.back as string, '/en/product/') &&
    !includes(router.options.history.state.back as string, '/th/product/')
  if (fromOtherPage) {
    reset()
  }
})

onMounted(() => {
  const productDetail = productDetailData?.value
  if (productDetail) {
    handleProductDetailData(productDetail)
  }
})
</script>

<style scoped></style>
